const constants = {
    DEFAULT_CATEGORY: 'default',
    MAX_DELETED_TASKS: 10
}

export default constants
